import React from "react";
const helpcanvas = {
  display: 'grid',
  gridTemplateColumns: '2fr 3fr 5fr',
  gridTemplateRows: 'min-content 1fr',
  backgroundColor: "#f2f2f2",
  height: '100vh',
  width: '100%',
  rowGap: '24px',
  columnGap: '14px',
  padding: '0 0 14px 0',
};

const helptitle = {
  color: "#222",
  backgroundColor: "#f2f2f2",
  padding: "2px",
  fontFamily: "Arial",
  fontSize: "13px",
};

const helpimg = {
    color: "#222",
    backgroundColor: "#f2f2f2",
    padding: "2px",
    fontFamily: "Arial",
  };

const UIDSSched = {
    name: 'DS Schedule a Scan',
    imageUrl: '../../images/DSSched.png',
    imageSize: "99%",
    bradius: 20,
  };

const UIDSSelectcat = {
    name: 'DS Category Select',
    imageUrl: '../../images/DSSelectcat.png',
    imageSize: "30%",
    bradius: 20,
  };

const UIDSSelectagent = {
    name: 'DS Category Select',
    imageUrl: '../../images/DSSelectagent.png',
    imageSize: "99%",
    bradius: 20,
  };

const UIDSRunningscans = {
    name: 'DS Category Select',
    imageUrl: '../../images/DSRunningscans.png',
    imageSize: "99%",
    bradius: 20,
  };


export const DSSched = () => {
  return (
    <div style={helpcanvas}>
      <div
      style={{ marginLeft: "310px" }}
      ></div>
      <div style={helptitle}><b>Schedule a Data Scan</b><br/><br/>
      In this section, vulnerability scans may be created, configured, and scheduled. <br/><br/>
      To create a new data scan: <br/><br/>
      <ul style={{marginLeft: '4em'}}>
      <li>Assign a scan name </li><br/>     
      <li>Select scan type (use the dropdown below Select Scan Type to choose from the following options: Local, 
      O365 Email, O365 OneDrive, SharePoint, Gmail and Google Drive) </li><br/> 
      <li>Set credentials - Select the credential to be used.  </li><br/> 
      </ul>
      <ul style={{marginLeft: '6em'}}>
      <li>If the <b>Use Default</b> option is selected, this will use the credential that has been previously assigned to this agent during agent setup. </li>
      <li>Should the agent require a different credential to access the target data to be scanned, simply select 
        the <b>use alternative</b> option and then supply the necessary credentials to the agent to perform the task. 
        Be sure to include the NetBIOS domain name in the domain field. If the agent is a standalone agent 
        (not on a domain), simply enter the Agent's NetBIOS name in place of the domain.</li></ul><br/>
      <ul style={{marginLeft: '4em'}}>
      <li>Select notification preference </li></ul><br/>
      <ul style={{marginLeft: '6em'}}>
      <li>Should an email notification be needed upon scan completion, select yes. </li></ul><br/>
      <ul style={{marginLeft: '4em'}}>
      <li>Schedule the scan to run either now or on a selected date</li></ul><br/>
      <ul style={{marginLeft: '6em'}}>
      <li>Run Now - as soon as the agent has availability </li>
      <li>One-time - to pick a future time for the scan to run, select the future time and date </li>
      <li>Recurring - select your recurrence schedule from the dropdowns.  </li></ul>

      </div>
      <div style={helpimg}>
      <img
        src={UIDSSched.imageUrl}
        alt={'Image of ' + UIDSSched.name}
        style={{
          width: UIDSSched.imageSize,
          borderRadius: UIDSSched.bradius,
        }}
      />
      </div>
    </div>
  );
};

export const DSSelectcat = () => {
  return (
    <div style={helpcanvas}>
      <div
      style={{ marginLeft: "310px" }}
      ></div>
      <div style={helptitle}><b>Select Sensitive Data Category </b><br/><br/>
      In the next section, pick a sensitive data category to scan for. Various data category groups are 
      presented, and each group can be opened to see specific categories included in the group. 
      Entire groups can be selected, or categories can be individually selected as shown here. <br/><br/>
      There is a generous variety of search categories that can be applied to this scan, such as: <br/><br/>
      <ol style={{marginLeft: '4em'}}>
      <li>Financial</li><br/>
      <li>Healthcare </li><br/>
      <li>PII </li><br/>
      <li>Organizational </li><br/>
      <li>Custom - Build your own custom scan that include keyword lists etc. </li></ol><br/><br/>
      Please note that the more scan categories selected, the longer the scan will take to run. Rather 
      than scanning for everything, it is better to scan for suspected data types which can then 
      be easily identified for mitigation. 
      </div>
      <div style={helpimg}>
      <img
        src={UIDSSelectcat.imageUrl}
        alt={'Image of ' + UIDSSelectcat.name}
        style={{
          width: UIDSSelectcat.imageSize,
          borderRadius: UIDSSelectcat.bradius,
        }}
      />
      </div>
    </div>
  );
};

export const DSSelectagent = () => {
  return (
    <div style={helpcanvas}>
      <div
      style={{ marginLeft: "310px" }}
      ></div>
      <div style={helptitle}><b>Select Agent and Targets</b><br/><br/>
      <h3>Excluded File Formats</h3><br/>For any exclusions, enter the names of the subfolders or file 
      types to be excluded in the Excluded File Formats field just above the Select Agent table. 
      Windows file types to be excluded should be in the form of *.. For example, to exclude Excel 
      files, create an entry for *.xls and use "Add a File Extension" to create an entry for *.xlsx. <br/><br/>
      <h3>Select Agent </h3><br/>
      Select the agent that will be assigned to perform this data scan. The agent selected should 
      have access to the data and be on the same network segment as the data that is going to be scanned. <br/><br/>
      Note: If a new scan agent is yet to be created, follow ADMIN -&gt; Scan Agents -&gt; ADD NEW SCAN AGENT. 
      For further guidance on adding a new scan agent, refer to the help section. <br/><br/>
      <h3>Select Target </h3><br/>
      After selecting an Agent, click on Select Targets next to the Agent to select the target machine 
      you want to scan.  <br/><br/>
      For Data Sensitivity scans, select a single agent to scan folders and shares of a single target. 
      A single target/location will produce manageable and concise results. To scan other locations or 
      targets, create additional scans. Following this approach allows much more focus to be given to 
      the corresponding mitigation plan for that individual target/location. <br/><br/>
      <h3>Review Scan Settings and Schedule Scan </h3><br/>
      Review the scan settings, and if no changes or further edits are required, then click Schedule 
      a Scan. To change anything in the data scan configuration, click on the edit icon in the Active Scans section.   
      </div>
      <div style={helpimg}>
      <img
        src={UIDSSelectagent.imageUrl}
        alt={'Image of ' + UIDSSelectagent.name}
        style={{
          width: UIDSSelectagent.imageSize,
          borderRadius: UIDSSelectagent.bradius,
        }}
      />
      </div>
    </div>
  );
};

export const DSRunningscans = () => {
  return (
    <div style={helpcanvas}>
      <div
      style={{ marginLeft: "310px" }}
      ></div>
      <div style={helptitle}><b>Scheduled Data Scans </b><br/><br/>
      You can view the Scheduled data scans for your instance here. The information 
      presented for each scan includes Scan Name, Frequency, Scan Type, number of Targets selected, 
      the next scan date, and options to either edit or delete the scans. <br/><br/>
      The search bar at the top right of the table allows you to search for specific scans. 
      </div>
      <div style={helpimg}>
      <img
        src={UIDSRunningscans.imageUrl}
        alt={'Image of ' + UIDSRunningscans.name}
        style={{
          width: UIDSRunningscans.imageSize,
          borderRadius: UIDSRunningscans.bradius,
        }}
      />
      </div>
    </div>
  );
};
